export default "__VITE_ASSET__oFX1hWzl__"